/**
 * GG Select Component
 * Reusable dropdown/select component
 */
export default class GGSelect {
  constructor(el, options = {}) {
    this.$el = $(el);
    this.$button = this.$el.find('.gg-select__button');
    this.$dropdown = this.$el.find('.gg-select__dropdown');
    this.$options = this.$el.find('.gg-select__option');
    this.dataSelectActive = 'data-select-active';

    // Get data-action attribute for custom event
    this.dataAction = this.$el.data('action') || null;

    // Callback when option is selected (optional, fallback)
    this.onSelect = options.onSelect || null;

    // Store the original/default label
    this.defaultLabel = this.$button.find('.gg-select__label').text().trim();

    this.init();

    // Attach instance to element for external access
    this.$el.data('ggSelect', this);
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Toggle dropdown
    this.$button.on('click', (_e) => {
      this.toggle();
    });

    // Select option
    this.$options.on('click', (e) => {
      e.preventDefault();
      const $option = $(e.currentTarget);
      const value = $option.data('value');
      const label = $option.text().trim();

      this.selectOption(value, label);
      this.close();

      // Trigger custom event if data-action is set
      if (this.dataAction) {
        $(document).trigger(this.dataAction, [value, label]);
      }

      // Trigger callback if provided (fallback for backward compatibility)
      if (this.onSelect && typeof this.onSelect === 'function') {
        this.onSelect(value, label);
      }
    });

    // Close dropdown when clicking outside
    $(document).on('click', (e) => {
      if (!$(e.target).closest('.gg-select').is(this.$el)) {
        this.close();
      }
    });

    // Close on ESC key
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.$button.attr(this.dataSelectActive, 'true');
    this.$dropdown.addClass('active');
  }

  close() {
    this.$button.attr(this.dataSelectActive, 'false');
    this.$dropdown.removeClass('active');
  }

  isOpen() {
    return this.$button.attr(this.dataSelectActive) === 'true';
  }

  selectOption(value, label) {
    // Update active state
    this.$options.removeClass('active');
    this.$options.filter(`[data-value="${value}"]`).addClass('active');

    // Optionally update button label
    this.$button.find('.gg-select__value').text(label);

    this.$el.addClass('selected');
  }

  getValue() {
    return this.$options.filter('.active').data('value');
  }

  setValue(value) {
    const $option = this.$options.filter(`[data-value="${value}"]`);
    if ($option.length) {
      const label = $option.text().trim();
      this.selectOption(value, label);
    }
  }

  reset() {
    // Remove active state from all options
    this.$options.removeClass('active');
    this.$options.first().addClass('active');
    // Reset button label to default
    this.$button.find('.gg-select__value').text('');

    // Remove selected class
    this.$el.removeClass('selected');

    // Close dropdown if open
    this.close();

    // Trigger custom event if data-action is set
    if (this.dataAction) {
      $(document).trigger(this.dataAction, ['', this.defaultLabel]);
    }

    // Trigger callback if provided
    if (this.onSelect && typeof this.onSelect === 'function') {
      this.onSelect('', this.defaultLabel);
    }
  }

  destroy() {
    this.$button.off('click');
    this.$options.off('click');
    this.$el.removeData('ggSelect');
  }
}

$(document).ready(() => {
  $('.gg-select').each((_index, el) => {
    if (!$(el).hasClass('running')) {
      new GGSelect(el);
      $(el).addClass('running');
    }
  });
});
